import { render, staticRenderFns } from "./UserAboutView.vue?vue&type=template&id=4492a1ee&scoped=true&"
import script from "./UserAboutView.vue?vue&type=script&lang=js&"
export * from "./UserAboutView.vue?vue&type=script&lang=js&"
import style0 from "./UserAboutView.vue?vue&type=style&index=0&id=4492a1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4492a1ee",
  null
  
)

export default component.exports